import React, { useCallback, useRef } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { CodesLayout, ReferencesLayout } from "../Layout";

function UserDefinedTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});

    const handleCodesFormLoad = useCallback(() => {
    }, []);

    const handleReferencesFormLoad = useCallback(() => {
    }, []);

    return (
        <TabPanel className="TabpanelContainer">
            <TabItem title="Codes">
                <FormField
                    currrentUser={currentUser}
                    layoutId='A1B2C3D4-E5F6-7890-ABCD-EF1234567890'
                    layoutName='SalesTaxCodeUserDefinedCodesTab'
                    defaultFormSchema={CodesLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={props.handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleCodesFormLoad}
                />
            </TabItem>
            <TabItem title="References">
                <FormField
                    currrentUser={currentUser}
                    layoutId='B2C3D4E5-F6A7-8901-BCDE-F12345678901'
                    layoutName='SalesTaxCodeUserDefinedRefTab'
                    defaultFormSchema={ReferencesLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={props.handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleReferencesFormLoad}
                />
            </TabItem>
        </TabPanel>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(UserDefinedTab);
